import { useLocalStorage } from "@rehooks/local-storage";
import { useCallback } from "react";

const SIDE_BY_SIDE_DIFF_STORAGE_KEY = "diff-view-side-by-side";

/**
 * Persists the "Show side by side" diff preference in local storage so it is
 * remembered across diff views
 */
const useSideBySideDiff = (defaultSideBySide = true) => {
  const [sideBySide, setSideBySide] = useLocalStorage<boolean>(
    SIDE_BY_SIDE_DIFF_STORAGE_KEY,
    defaultSideBySide
  );

  const toggleSideBySide = useCallback(
    () => setSideBySide(!sideBySide),
    [sideBySide, setSideBySide]
  );

  return { sideBySide, toggleSideBySide };
};

export default useSideBySideDiff;
